export const GAP_FILLER_ASSESSMENT_STEP = 'gap_filler_assessment_step'
